export const getValue = (name, configs = []) => {
  const value = configs.find((config) => config?.name === name)?.desc
  return value ?? null
}
